import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Step from "@/components/Step/Step";
import { ActionTypes, GetterTypes } from "@/store-vuex/types";
import { McsisConstants } from "@/models/constants/McsisConstants";
import { ApplicationDefaultValue } from "@/models/constants/ApplicationDefaultValue";

@Component({
  components: {
    Step
  }
})
export default class Stepper extends Vue {
  @Prop()
  public selectedStepNumber!: number;
  @Prop()
  public maxVisitedStepNumber!: number;
  public appointmentParticipantStepNumber = ApplicationDefaultValue.Number;
  public appointmentDetailsStepNumber = ApplicationDefaultValue.Number;
  public appointmentSelectionNumber = ApplicationDefaultValue.Number;
  public appointmentRecapStepNumber = ApplicationDefaultValue.Number;

  /**
   * Initialize the component data
   */
  public mounted() {
    const defaultIncrement = 1;

    if (
      this.selectedStepNumber === undefined ||
      this.selectedStepNumber === null
    ) {
      this.selectedStepNumber = defaultIncrement;
    }

    if (this.showAppointmentParticipantStep) {
      this.appointmentParticipantStepNumber = this.selectedStepNumber;
      this.appointmentDetailsStepNumber = this.showFirstStep
        ? this.appointmentParticipantStepNumber + defaultIncrement
        : this.appointmentParticipantStepNumber;
      this.appointmentSelectionNumber = this.appointmentDetailsStepNumber + defaultIncrement;
      this.appointmentRecapStepNumber = this.appointmentSelectionNumber + defaultIncrement;
    } else {
      this.appointmentParticipantStepNumber = ApplicationDefaultValue.Number;
      this.appointmentDetailsStepNumber = this.selectedStepNumber;
      this.appointmentSelectionNumber = this.showFirstStep
        ? this.appointmentDetailsStepNumber + defaultIncrement
        : this.appointmentDetailsStepNumber;
      this.appointmentRecapStepNumber = this.appointmentSelectionNumber + defaultIncrement;
    }
  }

  /**
   * Gets true if AppointmentParticipant step must be displayed
   *
   * @returns {boolean} true or false
   */
  public get showAppointmentParticipantStep(): boolean {
      return this.$store.getters[GetterTypes.showAppointmentParticipantStep];
  }

  public get useTRMGenderChoice(): boolean {
    return this.$store.getters[GetterTypes.useTRMGenderChoice];
  }

  public get useLongAppointment(): boolean {
    return this.$store.getters[GetterTypes.useLongAppointment];
  }

  public get allowFirstAppointment(): boolean {
    return this.$store.getters[GetterTypes.allowFirstAppointment];
  }

  public get isParticipantFirstAppointment(): boolean {
    return this.$store.getters[GetterTypes.isFirstAppointment];
  }

  public get showFirstAppointmentNotAllowed(): boolean {
    return !this.allowFirstAppointment && this.isParticipantFirstAppointment;
  }

  public get showFirstStep(): boolean {
    return (
      this.useTRMGenderChoice ||
      this.useLongAppointment ||
      this.showFirstAppointmentNotAllowed
    );
  }

  public isSelected(step: number): boolean {
    return this.selectedStepNumber === step;
  }

  public isPassed(step: number): boolean {
    return this.selectedStepNumber > step;
  }

  public isJumpable(step: number): boolean {
    return this.maxVisitedStepNumber >= step;
  }

  public onUpdateSelectedStepNumber(step: number): void {
    this.$emit("update-current-step-number", step);
  }

  @Watch("maxVisitedStepNumber")
  protected onMaxVisitedStepNumber(value: number, oldValue: number) {
    if (oldValue !== value) {
      if (value !== undefined) {
        this.$store.dispatch(ActionTypes.setMaxVisitedStepNumber, value);
      }
    }
  }
}
